import React, {FunctionComponent} from 'react';
import {timestampToPostDate} from "../../../helpers/date";
import {Link} from "react-router-dom";
import classnames from 'classnames';

interface IProps {
  alignment: 'left' | 'right';
  title: string;
  createdAt: number;
  slug: string;
  coverImage: string | null;
}

const EventItem: FunctionComponent<IProps> = ({
  alignment,
  title,
  createdAt,
  slug,
  coverImage,
}) => {
  return (
    <Link
      to={`/event/${slug}`}
      className={classnames({
        'flex flex-col items-center bg-white mt-8': true,
        'md:flex-row': alignment === 'left',
        'md:flex-row-reverse': alignment === 'right',
      })}
    >
      <div className="md:w-5/12 news__image-section">
        {coverImage && (
          <img className="w-full" src={coverImage!} alt="" />
        )}
      </div>
      <div
        className={classnames({
          'md:w-7/12 text-center py-8 px-8': true,
          'md:text-left': alignment === 'left',
          'md:text-right': alignment === 'right',
        })}
      >
        <time className="text-sm font-bold">{timestampToPostDate(createdAt)}</time>
        <h2 className="text-4xl font-bold mb-2">{title}</h2>
        <hr className="mb-4" />
        <a className="font-bold text-sm uppercase font-poppins">
          Read more
        </a>
      </div>
    </Link>
  )
};

export default EventItem;